import React, { useContext } from 'react';
import { Linking, Pressable } from 'react-native';
import Constants from 'expo-constants';
import { parseNodeStyles, parseTextColors } from './helper';
import Button from '../../Button';
import { Link } from '../../../text';
import AppContext from '../../../../contexts/App';

const LinkRenderer = ({ TDefaultRenderer, ...props }) => {
    const {
        state: { settings }
    } = useContext(AppContext);
    const classes = props?.tnode?.classes;
    const children = props?.tnode?.init?.domNode?.children;
    const href = props?.tnode?.attributes?.href;
    const nodeStyles = parseNodeStyles(props?.tnode?.attributes?.style);
    const textColor = classes.map(c => parseTextColors(c));
    const tNodeTagName = props?.tnode?.tagName;

    const hrefFactory = hrefValue => {
        if (hrefValue.includes(settings.websiteSettings.domain)) {
            return `${Constants.manifest2?.extra?.baseUrl}/${href.split('/').slice(3).join('/')}`;
        } else {
            return hrefValue;
        }
    };

    if (!children[0].data) {
        if (tNodeTagName === 'a' || tNodeTagName === 'btn' || tNodeTagName === 'button') {
            return (
                <Pressable onPress={() => Linking.openURL(hrefFactory(href), '_self')}>
                    <TDefaultRenderer {...props} />
                </Pressable>
            );
        } else {
            return <TDefaultRenderer {...props} />;
        }
    } else {
        if (classes?.includes('button') || classes?.includes('btn')) {
            return (
                <Button
                    onPress={() => Linking.openURL(hrefFactory(href), '_self')}
                    style={{ backgroundColor: '#ff0000', borderColor: '#ff0000', width: '45%' }}
                    text={children[0].data}
                    textStyle={{ color: '#fff' }}
                />
            );
        } else {
            return <Link onPress={() => Linking.openURL(hrefFactory(href), '_self')} style={{ ...props.style, ...nodeStyles }} text={children[0].data} />;
        }
    }
};

export default LinkRenderer;
